import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import CancelPurchaseComponent from '../components/cancel-purchase/index';

import {
  cancelPurchase,
  hideCancelPurchaseModal,
} from '../actions/index';

class CancelPurchase extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onKeepGroup = this.onKeepGroup.bind(this);
  }

  onSubmit(props) {
    const { purchaseId, authentication } = this.props;

    this.props.actions.cancelPurchase(purchaseId, authentication, { ...props, by: 'organizer' })
      .then(() => {
        this.props.actions.hideCancelPurchaseModal();
        this.props.onPurchaseCancelled();
      });
  }

  onKeepGroup() {
    this.props.actions.hideCancelPurchaseModal();
  }

  render() {
    return (
      <CancelPurchaseComponent
        onSubmit={this.onSubmit}
        onKeepGroup={this.onKeepGroup}

        purchaseName={this.props.purchaseName}
        initialValues={this.props.initialValues}
      />
    );
  }
}

CancelPurchase.defaultProps = {
  onPurchaseCancelled: () => {},
};

const mapStateToProps = ({ purchases, session }) => {
  const purchase = purchases.byId[purchases.current];

  return {
    purchaseId: purchase.id,
    purchaseName: purchase.product.name,
    authentication: session.authentication,
    contributorsCount: purchase.memberships.length,
    initialValues: {
      reason: '',
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  const containerActions = {
    cancelPurchase,
    hideCancelPurchaseModal,
  };

  return {
    actions: bindActionCreators(containerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelPurchase);




// WEBPACK FOOTER //
// ./src/desktop/containers/cancel-purchase.container.js